export default __webpack_public_path__ + "alberta-burger-close.84747e0bc19074d3e372.svg";